import { BackgroundImage } from "@/components/background/background-image";
import { cn } from "@/utils/cn";
import { IonContent, IonPage } from "@ionic/react";

interface FullScreenBackgroundContainerProps {
  children?: React.ReactNode;
  imageClassName: string;
  className?: string;
  backdrop?: boolean;
}

export const FullScreenBackgroundContainer = ({
  children,
  imageClassName,
  className,
  backdrop = false,
}: FullScreenBackgroundContainerProps) => {
  return (
    <IonPage>
      <IonContent fullscreen>
        <div
          className={cn(
            "mx-auto flex h-full w-full max-w-[480px] flex-col items-center justify-start gap-4 self-center p-4",
            className,
          )}
        >
          {children}
          <BackgroundImage imageClassName={imageClassName} backdrop={backdrop} />
        </div>
      </IonContent>
    </IonPage>
  );
};
